<template>
    <CustomDialog :value="value" @input="onInput" :defaultTitle="title" customClassTitle="poppinsSemiBold" noScroll>
        <template #content>
            <p class="ppv2-text-center ppv2-text-black poppinsRegular" :style="{ fontSize: normalizeFontSize(15) }">
                {{ description }}
            </p>
        </template>

        <template #actions>
            <BaseButton
                id="cancel-button"
                type="button"
                variant="outline"
                @click="onCancel"
                :customClass="`!ppv2-min-h-[40px] !ppv2-text-base !ppv2-min-w-[170px]`"
                :customHeight="45"
            >
                {{ $t('common.cancel') }}
            </BaseButton>
            <BaseButton
                id="confirm-button"
                type="submit"
                variant="danger"
                @click="onConfirm"
                :customClass="`!ppv2-min-h-[40px] !ppv2-text-base !ppv2-min-w-[170px]`"
                :customHeight="45"
            >
                {{ $t('common.confirm') }}
            </BaseButton>
        </template>
    </CustomDialog>
</template>

<script>
import CustomDialog from '../../../Shared/CustomDialog.vue'
import BaseButton from '../../../Shared//BaseButton.vue'
export default {
    name: 'ConfirmDeleteWeek',
    props: {
        // Vue 2 default prop for v-model
        value: {
            type: Boolean,
            required: true,
            default: false,
        },
        title: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            required: true,
        },
    },
    components: {
        CustomDialog,
        BaseButton,
    },
    methods: {
        onInput(val) {
            this.$emit('input', val)
        },
        onCancel() {
            this.$emit('input', false)
        },
        onConfirm() {
            this.$emit('confirm')
        },
        // If normalizeFontSize isn't global, add or import your method here:
        normalizeFontSize(size) {
            return this.$root.normalizeFontSize ? this.$root.normalizeFontSize(size) : `${size}px`
        },
    },
}
</script>
